import { Box } from '@coolblue-development/becky';
import { useChatContext } from '../../../../../contexts/ChatContext';
import ChatTab from '../ContactTab/ChatTab';

const ChatSidePanel = (): JSX.Element => {
  const { chatContacts } = useChatContext();

  return (
    <Box>
      {chatContacts?.map(contact => (
        <ChatTab key={contact} contactId={contact} />
      ))}
    </Box>
  );
};

export default ChatSidePanel;
